module.exports = __webpack_public_path__ + "img/listings.9a6643fb.svg";